import { Chip } from '@mui/material';
import { TranslateFunction } from '../../../../../hooks/useTranslate';
import { SRT_STATES } from '../../../consts/states';

const stateChipSRTConfig: Record<SRT_STATES, StateChipSRTProps> = {
    [SRT_STATES.PENDING]: { text: 'Pendiente', color: '#000', bgColor: '#EAE6E6' },
    [SRT_STATES.GENERATED]: { text: 'Generado', color: '#0E2510', bgColor: '#E3F5E3' },
    [SRT_STATES.ERROR]: { text: 'Error', color: '#BE2217', bgColor: '#FFE3E1' },
    [SRT_STATES.CORRECTED]: { text: 'Corregido', color: '#1473E6', bgColor: '#D9F1FF' }
};

export const renderStateChipSRT = (state: SRT_STATES, translate: TranslateFunction) => {
    const config = stateChipSRTConfig[state];
    return <StateChipSRT {...config} translate={translate}/>;
};

interface StateChipSRTProps {
    text: string;
    color: string;
    bgColor: string;
    translate?: TranslateFunction;
}

const StateChipSRT = ({ text, color, bgColor, translate = (key) => key }: StateChipSRTProps) => (
    <Chip
        label={translate(text)}
        sx={{
            bgcolor: bgColor,
            color: color,
            fontSize: '12px',
            fontWeight: 600,
            fontFamily: "Roboto, sans-serif",
            lineHeight: "1.5",
            letterSpacing: "0.02em",
        }}
    />
);

export default StateChipSRT;
